import React from 'react'
import ArrowIcon from './ArrowSvg'

const AnimatedArrow = props => {
  const { orientation = 'right', ...otherProps } = props
  var rotation = getRotation(orientation)
  return (
    <ArrowIcon
      height={6}
      fill="#e2e5e7"
      style={{
        transform: `rotate(${rotation}deg)`,
      }}
      {...otherProps}
    />
  )
}

export default AnimatedArrow

/**
 * Gets the rotation value in order to point the arrow in the provided
 * direction.
 * @param {string} direction
 * @returns {number}
 */
function getRotation(direction) {
  switch (direction) {
    case 'right':
      return 270
    case 'left':
      return 90
    case 'up':
      return 180
    case 'down':
    default:
      return 0
  }
}



// WEBPACK FOOTER //
// ./src/Components/Icons/AnimatedArrow/AnimatedArrow.js